import { render, staticRenderFns } from "./MoleculeEditionAcademyConfigurationModalEdit.vue?vue&type=template&id=0fc571ec&"
import script from "./MoleculeEditionAcademyConfigurationModalEdit.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyConfigurationModalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports